export default "/images/framework/BlueBg.b5c54e27.svg?b5c54e27";